// extracted by mini-css-extract-plugin
module.exports = {"learningTop":"boardsDetail_learningTop__2512K","catagory":"boardsDetail_catagory__QxbPr","slash":"boardsDetail_slash__28A2a"};